import { Prose } from '../../components/Prose'
import type { Profile } from '../../lib/metrics'
import { useTimer } from './TimerProvider'
import { clock, fmtInt } from '../../lib/format'
import { BREAKS } from '../content/data'

export function TimerTab({ profile }: { profile: Profile }) {
  // Sayaç state'i App seviyesindeki TimerProvider'da; burada sadece okunuyor.
  // Böylece sekme değiştirince sayaç sıfırlanmıyor.
  const t = useTimer()

  return (
    <>
      <div className="card">
        <h2>Mesai molası sayacı</h2>
        <Prose className="card-h">
          {profile.workMinutes} dakika çalış, {profile.breakMinutes} dakika ayakta ol.
          Sekme arkada olsa bile başlık yanıp söner, ses çalar ve bildirim düşer.
        </Prose>

        <div style={{ display: 'flex', alignItems: 'center', gap: 26, flexWrap: 'wrap', margin: '6px 0 18px' }}>
          <div>
            <div style={{ fontSize: 12, color: 'var(--muted)' }}>
              {t.phase === 'work' ? 'Çalışma' : 'MOLA — ayağa kalk'}
            </div>
            <div className="hero">{clock(t.left)}</div>
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {t.ringing && (
              <button className="primary" onClick={t.stopAlarm} aria-label="Alarmı sustur">
                🔕 Sustur
              </button>
            )}
            <button className={t.ringing ? '' : 'primary'} onClick={t.toggle}>
              {t.running ? 'Duraklat' : 'Başlat'}
            </button>
            <button onClick={t.reset}>Sıfırla</button>
            <button onClick={t.skip}>Atla →</button>
          </div>
        </div>
        <div className="bar-track" style={{ height: 10 }}>
          <div className="bar-fill bar-fill--tick" style={{
            width: `${t.progress * 100}%`,
            background: t.phase === 'work' ? 'var(--s1)' : 'var(--s2)',
          }} />
        </div>

        <div className="grid g3" style={{ marginTop: 18 }}>
          <div className="tile"><div className="lab">Bugün tamamlanan döngü</div>
            <div className="val">{t.cycles}</div><div className="dl">Hedef: günde 7–8</div></div>
          <div className="tile"><div className="lab">Ayakta geçen süre</div>
            <div className="val">{Math.round(t.standSeconds / 60)} dk</div><div className="dl">8 döngü ≈ 56 dk</div></div>
          <div className="tile"><div className="lab">Tahmini ekstra adım</div>
            <div className="val">{fmtInt(t.cycles * 350)}</div><div className="dl">Molada yürürsen ≈ 350 adım/mola</div></div>
        </div>

        <h3>Sayaç davranışı</h3>
        <Prose className="note" style={{ marginTop: 0, marginBottom: 8 }}>
          Süreler <strong>Ayarlar</strong> sekmesinde — orada değiştirdiğin an burası da değişir.
          Buradakiler bu cihaza özel, kaydedilmiyor.
        </Prose>
        <div className="grid g3">
          <div><label className="f">Ses</label>
            <select value={t.soundOn ? '1' : '0'} onChange={(e) => t.setSoundOn(e.target.value === '1')}>
              <option value="1">Açık</option><option value="0">Kapalı</option>
            </select></div>
          <div><label className="f">Alarm ne kadar çalsın</label>
            <select value={t.alarmMode} disabled={!t.soundOn}
                    onChange={(e) => t.setAlarmMode(e.target.value === 'once' ? 'once' : 'until_stopped')}>
              <option value="until_stopped">Ben susturana kadar</option>
              <option value="once">Bir kez çalsın</option>
            </select></div>
          <div><label className="f">Mola bitince</label>
            <select value={t.autoContinue ? '1' : '0'} onChange={(e) => t.setAutoContinue(e.target.value === '1')}>
              <option value="1">Otomatik devam et</option><option value="0">Beklet</option>
            </select></div>
        </div>
        <Prose className="note">
          {t.alarmMode === 'until_stopped'
            ? 'Alarm 3 saniyede bir tekrar ediyor; "Sustur" ya da herhangi bir sayaç düğmesine basınca kesiliyor. Masadan kalkmış olma ihtimaline karşı en fazla 5 dakika çalıyor — sonsuza kadar öten bir sekme kimseye yaramaz.'
            : 'Tek bip gürültülü ortamda kaçabiliyor. Duymadığını fark ediyorsan "Ben susturana kadar"a al.'}
        </Prose>
      </div>

      <div className="card">
        <h2>Molada ne yapılır</h2>
        <Prose className="card-h">Oturarak telefon karıştırmak mola değil. Sayaç mola verdiğinde bunlardan biri çıkar — seçme, çıkanı yap.</Prose>
        <div className="grid g2">
          {BREAKS.map((b) => (
            <div className="day" key={b[0]}>
              <div className="dt" style={{ fontSize: 14.5 }}>{b[0]}</div>
              <div className="dd">{b[1]}</div>
            </div>
          ))}
        </div>
        <div className="warnbox">
          Günde 8 mola × 350 adım ≈ <strong>2.800 ekstra adım</strong>. Hiçbir şey yapmadan, sadece kalkarak.
          7.000 adım hedefinin neredeyse yarısı buradan geliyor.
        </div>
      </div>
    </>
  )
}
